import {Link} from "react-router-dom";

function LoginSection() {
    return(
        <>
            <div className="my-account-area pt-100 pb-70">
                <div className="container">
                    <div className="login-form">
                        <form className="my-account-content" onSubmit={(e)=>e.preventDefault()}>
                            <div className="section-title">
                                <h2>Log In</h2>
                                <span className="top-title">Keep Connected With Us</span>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="email" className="form-control" placeholder="Email Address"/>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input minLength={8} required type="password" className="form-control" placeholder="Password"/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="form-group">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                                <label className="form-check-label" for="flexCheckDefault">
                                                    Remember Me
                                                </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="text-account">
                                        <p><Link to={'/forgot'}>Forgot Password?</Link> </p>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit" className="default-btn btn-style-fore">Login</button>
                                </div>
                            </div>
                            {/* <div className="border-or">
                                <span>Or Login With</span>
                            </div>
                            <div className="my-account-list">
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className='bx bxl-facebook'></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank">
                                            <i className='bx bxl-twitter' ></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/" target="_blank">
                                            <i className='bx bxl-linkedin' ></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.google.com/" target="_blank">
                                            <i className='bx bxl-google' ></i>
                                        </a>
                                    </li>
                                </ul>
                            </div> */}
                            <p>Don’t Have an Account? <Link to={'/register'}>Register</Link></p>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginSection